const getCollaboration = (rebrandLabels: ProductFragment.Base['rebrandLabels']): CollaborationsModule.Collaboration => {
  if (rebrandLabels?.extra?.includes('SAKS_SELECTED')) {
    return 'saks'
  }
}

export default getCollaboration
